
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';
  import routeService from '@/services/route.service';

  import steamService from '@/services/steam.service';

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'token',
        'redirectUrl'
      ])
    }
  })
  export default class SteamCallback extends Vue {
    data() {
      return {
        unwatch: null
      }
    };

    created() {
      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS') {
        if (this.$route.query["state"] != null) {
          this.$data.unwatch = this.$store.watch(() => this.$store.getters.token, token => {
            if (token == null) {
              routeService.redirectToLogin(this);
            }

            this.$store.dispatch("updateIsLinkingSteamLoading", true);
            this.$store.dispatch("updateIsLoading", true);

            steamService.callbackSteamPartner(this, token, this.$route.query["state"].toString());
          })
        }
        else {
          this.$router.push({ name: 'BadRequestError', query: { 'message': "This request should contain a state parameter." } });
        }
      } else {
        if (this.$route.query["openid.signed"] != null) {
          this.$data.unwatch = this.$store.watch(() => this.$store.getters.token, token => {
            if (token == null) {
              routeService.redirectToLogin(this);
            }

            this.$store.dispatch("updateIsLinkingSteamLoading", true);
            this.$store.dispatch("updateIsLoading", true);

            steamService.callbackSteam(this, token);
          })
        }
        else {
          this.$router.push({ name: 'BadRequestError', query: { 'message': "This request is not authorized by OpenId." } });
        }
      }
    }

    destroyed() {
      this.$data.unwatch();
    }
  }
